<template lang="html">
    <div class="editor">
        <div ref="toolbar" class="toolbar"></div>
        <div class="scroll_dv">
            <div ref="editor" class="text "></div>
        </div>
        <!-- <el-image lazy>
                    
        </el-image> -->
    </div>
</template>
<script>
import E from "wangeditor";
export default {
  name: "editoritem",
  data() {
    return {
      //   fileUploadAdd: this.apiList.upload,
      editor: null,
      info_: null,
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    isClear: {
      type: Boolean,
      default: false,
    },
    //用于修改的时候数据回显
    // contxt: {
    //   type: String,
    //   default: "",
    // },
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info_ = null;
      }
    },
    value: function (value) {
      // 使用v-model时，设置初始值
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    },
    //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  mounted() {
    this.seteditor();
    // 这一步非常重要，用于富文本修改信息的时候，数据回显
    // this.contxt是父子传参，动态传值的
    // this.editor.txt.html(this.contxt);
    this.editor.txt.html(this.value);
  },
  methods: {
    seteditor() {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      // 通过 url 参数配置 debug 模式。url 中带有 wangeditor_debug_mode=1 才会开启 debug 模式
      this.editor.customConfig.debug =
        location.href.indexOf("wangeditor_debug_mode=1") > 0;

      this.editor.customConfig.uploadImgShowBase64 = false; // base64存储图片
      this.editor.customConfig.showLinkImg = false; // 隐藏网络图片
      this.editor.customConfig.uploadImgServer = this.api.BASE_URL + this.api.BASE_URL_ADMIN_PATH + this.apiList.upload; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        token: localStorage.getItem(this.api.AUTH_TOKEN_FLAG), // 设置请求头
      }; // 自定义 header
      this.editor.customConfig.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // 自定义参数
      this.editor.customConfig.uploadImgParams = {
        item: "article",
        time: this.common.time,
        platform: this.common.platform,
        version: this.common.version,
      };

      // 配置菜单
      this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        // "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen", // 全屏
      ];

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
          console.log("fail", xhr, editor, result);
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          console.log("success", xhr, editor, result);
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          // 图片上传错误的回调
          console.log("error", xhr, editor);
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功，插入图片的回调
          // console.log("r", result);
          let url = result.data[0].url;
          insertImg(url); // insertImg()为插入图片的函数
        },
      };
      this.editor.customConfig.onchange = (html) => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
    },
  },
};
</script>

<style lang="css">
.scroll_dv{
    max-height:500px;
    overflow: scroll;
}
.editor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
  min-height: 300px;
}
</style>